module.exports = __webpack_public_path__ + "static/media/done_image.2771dee2.png";